const objFunc = () => {
  return {
    contactInfo: {}
  }
}

export default objFunc()

export const defaultObj = objFunc()
